import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import { EndPointService } from '../endpoint-service';
import { HttpClient, HttpParams } from '@angular/common/http';
// import { HttpClient, HttpParams } from '@angular/common/http';

declare var angular: angular.IAngularStatic;

interface Params {
    id?: any,
    name?: string,
}

@Injectable()
export class UploadGroupResource {
    private apiRoot:string;

    constructor(
        private http: HttpClient,
        private endpointService: EndPointService
    ) {
        this.apiRoot = this.endpointService.uploadGroupEndPoint;
    }

    get(params: Params):Observable<any> {
        return this.http.get(`${this.apiRoot}/${params.id}`)
    }

    getAll(params: any):Observable<any> {
        return this.http.get(`${this.apiRoot}`, {
            params: new HttpParams({fromObject: params})
        })
    }

    save(params: Params, body:any):Observable<any> {
        return this.http.post(`${this.apiRoot}/${params.id}`, body)
    }

    create(params: Params, body:any):Observable<any> {
            return this.http.post(`${this.apiRoot}`, body)
        }

    getUploadGroupUsers(params: Params):Observable<any> {console.log('getUploadGroupUsers',params)
        return this.http.get(`${this.apiRoot}/getUploadGroupUsers/${params.id}`)
    }

    getUploadGroupList(params: any):Observable<any> {
        return this.http.get(`${this.apiRoot}/getUploadGroupList`, {
            params: new HttpParams({fromObject: params})
        })
    }
}

angular.module('comcast.common.communication').factory('UploadGroupResourceFactory', downgradeInjectable(UploadGroupResource));